import axios from "axios";
import { authHeader, handleResponse } from "../../_helpers";
import { authenticationService } from "../authentication.service";
import { encData } from "../../_helpers/_helperFunctions";

function getAll(courseCategoryId) {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories?courseCategoryId=${courseCategoryId}`,
    requestOptions,
  ).then(handleResponse);
}

function getAllCourses() {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/get-all`,
    requestOptions,
  ).then(handleResponse);
}

function getContentLibaryCategroryById(id) {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/${id}`,
    requestOptions,
  ).then(handleResponse);
}

function create(formData) {
  const currentUser = authenticationService.currentUserValue;
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${currentUser.token}`,
      isenc: localStorage.getItem("isenc")
        ? parseInt(localStorage.getItem("isenc"), 10)
        : 0,
    },
    body: formData,
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/create`,
    requestOptions,
  ).then(handleResponse);
}

function update(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/create`,
    requestOptions,
  ).then(handleResponse);
}

function deleteContentCategory(categoryId, currentUserId, courseCategoryId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData({ categoryId, currentUserId, courseCategoryId }),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/delete`,
    requestOptions,
  ).then(handleResponse);
}

function getFilesByCategoryId(id) {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/getFiles/${id}`,
    requestOptions,
  ).then(handleResponse);
}

// function uploadFileToContentLibrary(id,data){
//     const currentUser = authenticationService.currentUserValue;
//     const requestOptions = {
//         method: 'POST',
//         headers: {
//             Authorization: `Bearer ${currentUser.token}`,
//             isenc:localStorage.getItem('isenc')?parseInt(localStorage.getItem('isenc')):0
//         },
//         body: data
//     };
//     return fetch(`${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/upload/${id}`, requestOptions).then(handleResponse);
// }

function uploadFileToContentLibrary(id, data) {
  const currentUser = authenticationService.currentUserValue;
  const headers = {
    Authorization: `Bearer ${currentUser.token}`,
    isenc: localStorage.getItem("isenc")
      ? parseInt(localStorage.getItem("isenc"), 10)
      : 0,
  };
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/upload/${id}`,
    data,
    headers,
  );
}

function getSignedLinkFromKey(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/get-file-url`,
    requestOptions,
  ).then(handleResponse);
}

function deleteFile(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/delete-file`,
    requestOptions,
  ).then(handleResponse);
}

function updateFileDetails(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/update-file-details`,
    requestOptions,
  ).then(handleResponse);
}

function saveFileInfo(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/save-file-info`,
    requestOptions,
  ).then(handleResponse);
}

function getFileDetailsById(id) {
  const requestOptions = { method: "GET", headers: authHeader() };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/getFileDetails/${id}`,
    requestOptions,
  ).then(handleResponse);
}

function reorderFiles(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/content-library-categories/reorder-files`,
    requestOptions,
  ).then(handleResponse);
}

export const contentLibraryService = {
  getAll,
  getAllCourses,
  getContentLibaryCategroryById,
  create,
  update,
  deleteContentCategory,
  getFilesByCategoryId,
  uploadFileToContentLibrary,
  getSignedLinkFromKey,
  deleteFile,
  updateFileDetails,
  saveFileInfo,
  reorderFiles,
  getFileDetailsById,
};
